export const LAYOUT = {
  COMMON: {
    TITLE: {
      UNSAVED_CHANGES: 'LAYOUT.COMMON.TITLE.UNSAVED_CHANGES',
    },

    MESSAGE: {
      UNSAVED_CHANGES: 'LAYOUT.COMMON.MESSAGE.UNSAVED_CHANGES',
    },

    BUTTON: {
      LEAVE_WITHOUT_SAVING: 'LAYOUT.COMMON.BUTTON.LEAVE_WITHOUT_SAVING',
      CANCEL: 'LAYOUT.COMMON.BUTTON.CANCEL',
    },
  },
  // Favoritos: el grupo del menu lateral y la estrella de la ventana.
  FAVORITES: {
    TITLE: 'LAYOUT.FAVORITES.TITLE',
    ADD: 'LAYOUT.FAVORITES.ADD',
    REMOVE: 'LAYOUT.FAVORITES.REMOVE',
  },
  // Nebulina: el lanzador del area de trabajo y su panel.
  NEBULINA: {
    LAUNCHER: 'LAYOUT.NEBULINA.LAUNCHER',
    BUBBLE: 'LAYOUT.NEBULINA.BUBBLE',
    BUBBLE_HERE: 'LAYOUT.NEBULINA.BUBBLE_HERE',
    BUBBLE_TYPING: 'LAYOUT.NEBULINA.BUBBLE_TYPING',
    NAME: 'LAYOUT.NEBULINA.NAME',
    SUBTITLE: 'LAYOUT.NEBULINA.SUBTITLE',
    NEW_CONVERSATION: 'LAYOUT.NEBULINA.NEW_CONVERSATION',
    MINIMIZE: 'LAYOUT.NEBULINA.MINIMIZE',
    // Cerrar y Detener ya existen en el bundle: se reutilizan (R-G11).
    CLOSE: 'LAYOUT.CLOSE',
    GREETING: 'LAYOUT.NEBULINA.GREETING',
    HELP_QUESTION: 'LAYOUT.NEBULINA.HELP_QUESTION',
    SUGGESTIONS_TITLE: 'LAYOUT.NEBULINA.SUGGESTIONS_TITLE',
    SUGGESTION_SCREEN: 'LAYOUT.NEBULINA.SUGGESTION_SCREEN',
    SUGGESTION_SEARCH: 'LAYOUT.NEBULINA.SUGGESTION_SEARCH',
    SUGGESTION_EXPORT: 'LAYOUT.NEBULINA.SUGGESTION_EXPORT',
    CONTEXT_REMOVE: 'LAYOUT.NEBULINA.CONTEXT_REMOVE',
    CONTEXT_USE: 'LAYOUT.NEBULINA.CONTEXT_USE',
    CONTEXT_INFO: 'LAYOUT.NEBULINA.CONTEXT_INFO',
    PLACEHOLDER: 'LAYOUT.NEBULINA.PLACEHOLDER',
    SEND: 'LAYOUT.NEBULINA.SEND',
    SEND_EMPTY: 'LAYOUT.NEBULINA.SEND_EMPTY',
    STOP: 'ACTIONS.STOP',
    STOP_TITLE: 'LAYOUT.NEBULINA.STOP_TITLE',
    THINKING: 'LAYOUT.NEBULINA.THINKING',
    // Respuestas que no llegan de la IA: siempre texto del front, nunca el del servidor (R-G15).
    ERROR_QUOTA: 'LAYOUT.NEBULINA.ERROR_QUOTA',
    ERROR_NOT_CONFIGURED: 'LAYOUT.NEBULINA.ERROR_NOT_CONFIGURED',
    ERROR_KEY_MISSING: 'LAYOUT.NEBULINA.ERROR_KEY_MISSING',
    ERROR_DISABLED: 'LAYOUT.NEBULINA.ERROR_DISABLED',
    ERROR_UNAVAILABLE: 'LAYOUT.NEBULINA.ERROR_UNAVAILABLE',
    ERROR_KEY_REJECTED: 'LAYOUT.NEBULINA.ERROR_KEY_REJECTED',
    ERROR_TIMEOUT: 'LAYOUT.NEBULINA.ERROR_TIMEOUT',
    ERROR_GENERIC: 'LAYOUT.NEBULINA.ERROR_GENERIC',
    DISCLAIMER: 'LAYOUT.NEBULINA.DISCLAIMER',
  },
  // Menú principal - módulos
  MENU: {
    // Módulos principales
    ACCOUNTING: 'LAYOUT.MENU.ACCOUNTING',
    BILLING: 'LAYOUT.MENU.BILLING',
    MASTERS: 'LAYOUT.MENU.MASTERS',
    TREASURY: 'LAYOUT.MENU.TREASURY',
    BUDGET: 'LAYOUT.MENU.BUDGET',
    VAULT: 'LAYOUT.MENU.VAULT',
    // Nota: algunos nombres de módulos no están en el mapeo, pero los agregamos por si acaso
    PRODUCTS: 'LAYOUT.MENU.PRODUCTS',
    COMPANY: 'LAYOUT.MENU.COMPANY',
    // Submódulos comunes
    HOME: 'COMMON_HOME', // ya existe en el mapeo global, pero lo dejamos como referencia
  },

  // Etiquetas de opciones y parámetros (usadas en el menú lateral)
  OPTIONS: {
    // Contabilidad
    ACCOUNTING_PARAMETERS: 'OPTIONS_ACCOUNTING_PARAMETERS',
    ACCOUNT_PLAN_TYPE: 'OPTIONS_ACCOUNT_PLAN_TYPE',
    TIPO_PLAN: 'OPTIONS_TIPO_PLAN',
    TIPO_PLAN_HISTORICO: 'OPTIONS_TIPO_PLAN_HISTORICO',
    PLAN_CUENTAS_HISTORICO: 'OPTIONS_PLAN_CUENTAS_HISTORICO',
    ESTRUCTURA_HISTORICO: 'OPTIONS_ESTRUCTURA_HISTORICO',
    COST_CENTER: 'OPTIONS_COST_CENTER',
    COST_CENTER_TYPE: 'OPTIONS_COST_CENTER_TYPE',
    ACCOUNT_PLAN: 'OPTIONS_ACCOUNT_PLAN',
    ACCOUNT_STRUCTURE: 'OPTIONS_ACCOUNT_STRUCTURE',
    COUNTRY: 'OPTIONS_COUNTRY',
    DEPARTMENT: 'OPTIONS_DEPARTMENT',
    CITY: 'OPTIONS_CITY',
    DEPENDENCY: 'OPTIONS_DEPENDENCY',
    ACCOUNTING_FORMAT: 'OPTIONS_ACCOUNTING_FORMAT',
    DIAN_CONCEPT: 'OPTIONS_DIAN_CONCEPT',
    DEFERRED: 'OPTIONS_DEFERRED',
    ACCRUAL: 'OPTIONS_ACCRUAL',
    ACCRUAL_APPROVAL: 'OPTIONS_ACCRUAL_APPROVAL',
    ACCRUAL_ANNULMENT: 'OPTIONS_ACCRUAL_ANNULMENT',
    JOURNAL_ENTRY: 'OPTIONS_JOURNAL_ENTRY',
    JOURNAL_ENTRY_ANNULMENT: 'OPTIONS_JOURNAL_ENTRY_ANNULMENT',
    DEPRECIATION: 'OPTIONS_DEPRECIATION',
    DEFERRED_PROCESS: 'OPTIONS_DEFERRED_PROCESS',
    ACCOUNTING_CLOSURE: 'OPTIONS_ACCOUNTING_CLOSURE',
    BANK_RECONCILIATION_CONFIG: 'OPTIONS_BANK_RECONCILIATION_CONFIG',
    BANK_RECONCILIATION: 'OPTIONS_BANK_RECONCILIATION',
    BANK_ACCOUNT: 'OPTIONS_BANK_ACCOUNT',
    EMBARGO: 'OPTIONS_EMBARGO',
    OTHER_DISCOUNT: 'OPTIONS_OTHER_DISCOUNT',
    CONFIG_DIAN_CONCEPTS: 'OPTIONS_CONFIG_DIAN_CONCEPTS',
    ACCOUNTING_CLOSE: 'OPTIONS_ACCOUNTING_CLOSE',
    // Tesorería
    TREASURY_PARAMETERS: 'OPTIONS_TREASURY_PARAMETERS',
    TREASURY_THIRD_PARTY: 'OPTIONS_TREASURY_THIRD_PARTY',
    INCOME_VOUCHER: 'OPTIONS_INCOME_VOUCHER',
    PAYMENT_ORDER_RECEPTION: 'OPTIONS_PAYMENT_ORDER_RECEPTION',
    EXPENSE_VOUCHER: 'OPTIONS_EXPENSE_VOUCHER',
    BANK_PAYMENT: 'OPTIONS_BANK_PAYMENT',
    PAYMENT_ANNULMENT: 'OPTIONS_PAYMENT_ANNULMENT',
    PAYMENT_CONFIRMATION: 'OPTIONS_PAYMENT_CONFIRMATION',
    ELECTRONIC_PAYMENT_CONFIG: 'OPTIONS_ELECTRONIC_PAYMENT_CONFIG',
    ELECTRONIC_PAYMENT_GEN: 'OPTIONS_ELECTRONIC_PAYMENT_GEN',
    BANK_TRANSFER: 'OPTIONS_BANK_TRANSFER',
    BANK_TRANSFER_ANNULMENT: 'OPTIONS_BANK_TRANSFER_ANNULMENT',
    BANK_CLOSURE: 'OPTIONS_BANK_CLOSURE',
    // Budget
    BUDGET_PARAMETERS: 'OPTIONS_BUDGET_PARAMETERS',
    RESOURCE_TYPE: 'BUDGET.RESOURCE_TYPE.TITLE.LIST',
    FUNDING_SOURCE: 'OPTIONS_FUNDING_SOURCE',
    PROJECTS: 'OPTIONS_PROJECTS',

    //INVOICING
    INVOICE_APPROVAL: 'OPTIONS_INVOICE_APPROVAL',
    INVOICE_ANNULMENT: 'OPTIONS_INVOICE_ANNULMENT',
    CREDIT_NOTE_APPROVAL: 'OPTIONS_CREDIT_NOTE_APPROVAL',
    CREDIT_DEBIT: 'OPTIONS_CREDIT_DEBIT',

    // Billing
    BILLING_PARAMETERS: 'OPTIONS_BILLING_PARAMETERS',
    BILLING_CONCEPT: 'OPTIONS_BILLING_CONCEPT',
    INVOICE_ELABORATION: 'OPTIONS_INVOICE_ELABORATION',
    CREDIT_DEBIT_NOTE: 'OPTIONS_CREDIT_DEBIT_NOTE',
    CURRENCY: 'OPTIONS_CURRENCY',
    // Vault
    VAULT_DASHBOARD: 'OPTIONS_VAULT_DASHBOARD',
    VAULT_INGEST: 'OPTIONS_VAULT_INGEST',
    VAULT_PRESERVATION: 'OPTIONS_VAULT_PRESERVATION',
    VAULT_RETENTION: 'OPTIONS_VAULT_RETENTION',
    VAULT_LEGAL_HOLD: 'OPTIONS_VAULT_LEGAL_HOLD',
    VAULT_REPORTS: 'OPTIONS_VAULT_REPORTS',
    VAULT_CLOUD: 'OPTIONS_VAULT_CLOUD',
    VAULT_NOTIFICATIONS: 'OPTIONS_VAULT_NOTIFICATIONS',
    VAULT_AUDIT: 'OPTIONS_VAULT_AUDIT',
    VAULT_SETTINGS: 'OPTIONS_VAULT_SETTINGS',
    VAULT_ADMIN_DASHBOARD: 'OPTIONS_VAULT_ADMIN_DASHBOARD',
    LEGAL_HOLD: 'LEGAL_HOLD',
    VAULT_ADMIN_TENANTS: 'OPTIONS_VAULT_ADMIN_TENANTS',
    VAULT_ADMIN_MODULE_PERMISSIONS: 'OPTIONS_VAULT_ADMIN_MODULE_PERMISSIONS',
    VAULT_ADMIN_SERVERS: 'OPTIONS_VAULT_ADMIN_SERVERS',
    VAULT_ADMIN_USERS: 'OPTIONS_VAULT_ADMIN_USERS',
    VAULT_REPOSITORIO_ADMIN: 'OPTIONS_VAULT_REPOSITORIO_ADMIN',
    VAULT_PRESERVATION_MESSAGES: 'OPTIONS_VAULT_PRESERVATION_MESSAGES',
    // Otros
    NEBULA_ROLES: 'OPTIONS_NEBULA_ROLES',
    ACCIONES_TRIGGERS: 'OPTIONS_ACCIONES_TRIGGERS',
    THIRD_PARTY: 'OPTIONS_THIRD_PARTY',
    CONSECUTIVE: 'OPTIONS_CONSECUTIVE',
    CONSECUTIVE_TYPE: 'OPTIONS_CONSECUTIVE_TYPE',
    PARAMETERS_DEFINITION: 'OPTIONS_PARAMETERS_DEFINITION',
    PARAMETERS_TEMPLATE: 'OPTIONS_PARAMETERS_TEMPLATE',
    PARAMETERS_ROLE: 'OPTIONS_PARAMETERS_ROLE',
    PARAMETERS_COMPANY: 'OPTIONS_PARAMETERS_COMPANY',
    FILE_SCRUCTURE_CONFIG: 'OPTIONS_FILE_STRUCTURE_CONFIG',
    OPTIONS_PAYMENT_FILES: 'OPTIONS_PAYMENT_FILES',
    OPTIONS_BANK_CLOSURES: 'OPTIONS_BANK_CLOSURES',
  },

  // Submódulos (usados para agrupar en el menú)
  SUB_MODULES: {
    // Contabilidad
    ACCOUNTING_HISTORICO: 'SUB_MODULES_ACCOUNTING_HISTORICO_NAME',
    ACCOUNTING_MASTERS: 'SUB_MODULES_ACCOUNTING_MASTERS_NAME',
    ACCOUNTING_CONFIG: 'SUB_MODULES_ACCOUNTING_CONFIG_NAME',
    ACCOUNTING_OPERATIONS: 'SUB_MODULES_ACCOUNTING_OPERATIONS_NAME',
    ACCOUNTING_BANKING: 'SUB_MODULES_ACCOUNTING_BANKING_NAME',
    // Tesorería
    TREASURY_MASTERS: 'SUB_MODULES_TREASURY_MASTERS_NAME',
    TREASURY_OPERATIONS: 'SUB_MODULES_TREASURY_OPERATIONS_NAME',
    TREASURY_ELECTRONIC: 'SUB_MODULES_TREASURY_ELECTRONIC_NAME',
    TREASURY_BANKING: 'SUB_MODULES_TREASURY_BANKING_NAME',
    // Budget
    BUDGET_MASTERS: 'SUB_MODULES_BUDGET_MASTERS_NAME',
    // Billing
    BILLING_CONFIG: 'SUB_MODULES_BILLING_CONFIG_NAME',
    BILLING_OPERATIONS: 'SUB_MODULES_BILLING_OPERATIONS_NAME',
    // Vault
    VAULT_HOME: 'SUB_MODULES_VAULT_HOME_NAME',
    VAULT_DOCUMENTAL: 'SUB_MODULES_VAULT_DOCUMENTAL_NAME',
    VAULT_SYSTEM: 'SUB_MODULES_VAULT_SYSTEM_NAME',
    VAULT_ADMIN: 'SUB_MODULES_VAULT_ADMIN_NAME',
    // Maestros
    MASTERS_CONSECUTIVES: 'SUB_MODULES_MASTERS_CONSECUTIVES_NAME',
    CONFIG_PARAMETERS: 'SUB_MODULES_CONFIG_PARAMETERS_NAME',
  },

  // Rutas y segmentos (usados en getLabelForRouteSegment)
  ROUTE: {
    // Módulos principales
    ACCOUNTING: 'BC.accounting',
    BILLING: 'BC.billing',
    BUDGET: 'BC.budget',
    PRODUCTS: 'BC.products',
    COMPANY: 'BC.company',
    VAULT: 'BC.vault',
    MASTERS: 'BC.masters',

    // Secciones comunes
    LIST: 'BC.list',
    CREATE: 'BC.create',
    EDIT: 'BC.edit',
    DETAIL: 'BC.detail',
    VIEW: 'BC.view',
    DASHBOARD: 'BC.dashboard',

    // Vault específico
    INGEST: 'BC.ingest',
    PRESERVATION: 'BC.preservation',
    RETENTION: 'BC.retention',
    LEGAL_HOLD: 'BC.legal-hold',
    REPORTS: 'BC.reports',
    CLOUD: 'BC.cloud',
    NOTIFICATIONS: 'BC.notifications',
    AUDIT: 'BC.audit',
    SETTINGS: 'BC.settings',
    ADMIN: 'BC.admin',
    TENANTS: 'BC.tenants',
    PERMISSIONS: 'BC.permissions',
    SERVERS: 'BC.servers',
    PRESERVATION_MESSAGES: 'BC.preservation-messages',
    REPOSITORY_ADMIN: 'BC.repository-admin',

    // Contabilidad específica
    ACCOUNTING_PARAMETERS: 'BC.accounting-parameters',
    TIPO_PLAN: 'BC.tipo-plan',
    TIPO_PLAN_HISTORICO: 'BC.tipo-plan-historico',
    DEPENDENCY: 'BC.dependency',
    DIAN_CONCEPT: 'BC.dian-concept',
    ACCOUNT_STRUCTURE: 'BC.account-structure',
    CURRENCY: 'BC.currency',
    ACCOUNT_PLAN: 'BC.account-plan',
    THIRD_PARTY: 'BC.third-party',
    ACCOUNTING_FORMAT: 'BC.accounting-format',
    ACCRUAL: 'BC.accrual',
    DEFERRED_PROCESS: 'BC.deferred-process',
    JOURNAL_ENTRY: 'BC.journal-entry',
    ACCRUAL_APPROVAL: 'BC.accrual-approval',
    ACCRUAL_ANNULMENT: 'BC.accrual-annulment',
    TREASURY_PARAMETERS: 'BC.treasury-parameters',
    DEPRECIATION: 'BC.depreciation',
    JOURNAL_ENTRY_ANNULMENT: 'BC.journal-entry-annulment',
    BANK_ACCOUNT: 'BC.bank-account',
    OTHER_DISCOUNT: 'BC.other-discount',
  },
  VALIDATION: {
    REQUIRED: {
      DOCUMENT_TYPE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.DOCUMENT_TYPE',
      DOCUMENT_NUMBER: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.DOCUMENT_NUMBER',
      PERSON_TYPE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.PERSON_TYPE',
      FIRST_NAME: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.FIRST_NAME',
      FIRST_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.FIRST_SURNAME',
      BUSINESS_NAME: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.BUSINESS_NAME',
      ADDRESS: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.ADDRESS',
      COUNTRY: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.COUNTRY',
      CITY: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.CITY',
      PHONE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.PHONE',
      MOBILE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.MOBILE',
      EMAIL: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.EMAIL',
      ECONOMIC_ACTIVITY_CODE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED.ECONOMIC_ACTIVITY_CODE',
    },
    REQUIRED_FALLBACK: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.REQUIRED_FALLBACK',
    EMAIL_INVALID: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.EMAIL_INVALID',
    DV_INVALID: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.DV_INVALID',
    DUPLICATE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.DUPLICATE',
    MIN_LENGTH: {
      DOCUMENT_NUMBER: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MIN_LENGTH.DOCUMENT_NUMBER',
      FIRST_NAME: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MIN_LENGTH.FIRST_NAME',
      FIRST_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MIN_LENGTH.FIRST_SURNAME',
      BUSINESS_NAME: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MIN_LENGTH.BUSINESS_NAME',
      ADDRESS: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MIN_LENGTH.ADDRESS',
      PHONE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MIN_LENGTH.PHONE',
      MOBILE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MIN_LENGTH.MOBILE',
      FALLBACK: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MIN_LENGTH.FALLBACK',
    },
    MAX_LENGTH: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.MAX_LENGTH',
    PATTERN: {
      DOCUMENT_NUMBER: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.PATTERN.DOCUMENT_NUMBER',
      FIRST_NAME: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.PATTERN.FIRST_NAME',
      FIRST_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.PATTERN.FIRST_SURNAME',
      DV: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.PATTERN.DV',
      PHONE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.PATTERN.PHONE',
      MOBILE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.PATTERN.MOBILE',
      ECONOMIC_ACTIVITY_CODE: 'LAYOUT.THIRD_PARTY.FORM.VALIDATION.PATTERN.ECONOMIC_ACTIVITY_CODE',
    },
    // Tipos de persona
    PERSON_TYPE: {
      NATURAL: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.PERSON_TYPE.NATURAL',
      JURIDICA: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.PERSON_TYPE.JURIDICA',
    },
    // Tipos de vínculo
    LINK_TYPE: {
      PROVEEDOR: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.PROVEEDOR',
      CLIENTE: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.CLIENTE',
      EMPLEADO: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.EMPLEADO',
      ENTIDAD_PUBLICA: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.ENTIDAD_PUBLICA',
      ENTIDAD_BANCARIA: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.LINK_TYPE.ENTIDAD_BANCARIA',
    },
    // Regímenes tributarios
    TAX_REGIME: {
      ORDINARIO: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.ORDINARIO',
      SIMPLE: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.SIMPLE',
      ESPECIAL: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.ESPECIAL',
      NO_RESPONSABLE_IVA: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.TAX_REGIME.NO_RESPONSABLE_IVA',
    },
    // Tipos de cuenta bancaria
    ACCOUNT_TYPE: {
      CORRIENTE: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.CORRIENTE',
      AHORROS: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.AHORROS',
      DEPOSITO_ELECTRONICO: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.DEPOSITO_ELECTRONICO',
      PENSIONADO: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.ACCOUNT_TYPE.PENSIONADO',
    },
    // Mensajes y textos del layout
    DOCUMENT_TYPE: {
      CC: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.CC',
      RC: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.RC',
      TI: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.TI',
      PP: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.PP',
      NIT: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.NIT',
      CE: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.CE',
      PEP: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.PEP',
      IE: 'LAYOUT.THIRD_PARTY.FORM.OPTIONS.DOCUMENT_TYPE.IE',
    },
    MESSAGES: {
      CREATE: 'LAYOUT.THIRD_PARTY.MESSAGES.SUCCESS.CREATE',
      UPDATE: 'LAYOUT.THIRD_PARTY.MESSAGES.SUCCESS.UPDATE',
      DELETE: 'LAYOUT.THIRD_PARTY.MESSAGES.SUCCESS.DELETE',
      REQUIRED_FIELDS: 'LAYOUT.THIRD_PARTY.MESSAGES.WARNING.REQUIRED_FIELDS',
      NO_VINCULOS: 'LAYOUT.THIRD_PARTY.MESSAGES.WARNING.NO_VINCULOS',
      DUPLICATE_VINCULO: 'LAYOUT.THIRD_PARTY.MESSAGES.WARNING.DUPLICATE_VINCULO',
      UNIQUE_ACTIVE_ACCOUNT: 'LAYOUT.THIRD_PARTY.MESSAGES.WARNING.UNIQUE_ACTIVE_ACCOUNT',
      DELETE_ONLY_INACTIVE: 'LAYOUT.THIRD_PARTY.MESSAGES.WARNING.DELETE_ONLY_INACTIVE',
      INACTIVE_NOT_EDITABLE: 'LAYOUT.THIRD_PARTY.MESSAGES.WARNING.INACTIVE_NOT_EDITABLE',
      DOCUMENT_IMMUTABLE: 'LAYOUT.THIRD_PARTY.MESSAGES.WARNING.DOCUMENT_IMMUTABLE',
      LOAD: 'LAYOUT.THIRD_PARTY.MESSAGES.ERROR.LOAD',
      ERROR_CREATE: 'LAYOUT.THIRD_PARTY.MESSAGES.ERROR.CREATE',
      ERROR_UPDATE: 'LAYOUT.THIRD_PARTY.MESSAGES.ERROR.UPDATE',
      ERROR_DELETE: 'LAYOUT.THIRD_PARTY.MESSAGES.ERROR.DELETE',
      ERROR_LOAD_DETAIL: 'LAYOUT.THIRD_PARTY.MESSAGES.ERROR.LOAD_DETAIL',
      MESSAGE: 'LAYOUT.THIRD_PARTY.EMPTY.MESSAGE',
      DESCRIPTION: 'LAYOUT.THIRD_PARTY.EMPTY.DESCRIPTION',
      YES: 'COMMON.YES',
      ACTIVE: 'COMMON.ACTIVE',
      INACTIVE: 'COMMON.INACTIVE',
      NO: 'COMMON.NO',
      MAX_TABS: 'LAYOUT.MAX_TABS',
      CONN_OK: 'LAYOUT.CONN_OK',
      CONN_FAIL: 'LAYOUT.CONN_FAIL',
      FOOTER_COPYRIGHT: 'LAYOUT.FOOTER_COPYRIGHT',
      SEARCH_PLACEHOLDER: 'LAYOUT.SEARCH_PLACEHOLDER',
      SYSTEM_DATE: 'LAYOUT.SYSTEM_DATE',
      CLOSE: 'LAYOUT.CLOSE',
      CLOSE_ALL: 'LAYOUT.CLOSE_ALL',
      CLOSE_LEFT: 'LAYOUT.CLOSE_LEFT',
      CLOSE_OTHERS: 'LAYOUT.CLOSE_OTHERS',
      CLOSE_RIGHT: 'LAYOUT.CLOSE_RIGHT',
      CLOSE_MENU: 'LAYOUT.CLOSE_MENU',
      NO_OPEN_TABS: 'LAYOUT.NO_OPEN_TABS',
      TABS_MENU_TOOLTIP: 'LAYOUT.TABS_MENU_TOOLTIP',
      TABS_OPEN: 'LAYOUT.TABS_OPEN',
      LANGUAGE: 'LAYOUT.LANGUAGE',
      INDICATIVE: 'LAYOUT.INDICATIVE',
      POSTAL_CODE: 'LAYOUT.POSTAL_CODE',
      ACTIONS: 'LAYOUT.COMMON.ACTIONS',
      USER_DEFAULT_NAME: 'COMMON.USER_DEFAULT_NAME',
      ACTION_LABEL: 'COMMON.ACTION_LABEL',
      TITLE_DEPARTMENTS: 'LAYOUT.TITLE_DEPARTMENTS',
      TITLE_CREATE_DEPARTMENT: 'LAYOUT.TITLE_CREATE_DEPARTMENT',
      TITLE_EDIT_DEPARTMENT: 'LAYOUT.TITLE_EDIT_DEPARTMENT',
      TITLE_VIEW_DEPARTMENT: 'ACTIONS.CONSULT',
      SUBTITLE_DEPARTMENT_DETAILS: 'LAYOUT.SUBTITLE_DEPARTMENT_DETAILS',
      SUBTITLE_COUNTRY_DETAILS: 'LAYOUT.SUBTITLE_COUNTRY_DETAILS',
      SUBTITLE_CITY_DETAILS: 'LAYOUT.SUBTITLE_CITY_DETAILS',
      SUBTITLE_DEPENDENCY_DETAILS: 'LAYOUT.SUBTITLE_DEPENDENCY_DETAILS',
      SUBTITLE_CITIES: 'LAYOUT.SUBTITLE_CITIES',
      SUBTITLE_COUNTRIES: 'LAYOUT.SUBTITLE_COUNTRIES',
      SUBTITLE_DEPARTMENTS: 'LAYOUT.SUBTITLE_DEPARTMENTS',
      NO_OPTIONS_FOUND: 'LAYOUT.NO_OPTIONS_FOUND',
      RESULT: 'LAYOUT.RESULT',
      RESULTS: 'LAYOUT.RESULTS',
      SHOWING: 'LAYOUT.SHOWING',
      OF: 'LAYOUT.OF',
      CITY_SG: 'LAYOUT.CITY_SG',
      CITY_PL: 'LAYOUT.CITY_PL',
      COUNTRY_SG: 'LAYOUT.COUNTRY_SG',
      COUNTRY_PL: 'LAYOUT.COUNTRY_PL',
      DEPARTMENT_SG: 'LAYOUT.DEPARTMENT_SG',
      DEPARTMENT_PL: 'LAYOUT.DEPARTMENT_PL',
      THIRD_PARTY: {
        TITLE: 'LAYOUT.THIRD_PARTY.TITLE',
        SUBTITLE: 'LAYOUT.THIRD_PARTY.SUBTITLE',
        EMPTY: 'LAYOUT.THIRD_PARTY.EMPTY', // si necesitas mensaje de vacío
        SEARCH_PLACEHOLDER: 'LAYOUT.THIRD_PARTY.SEARCH_PLACEHOLDER',
      },
      THIRD_PARTY_SG: 'LAYOUT.THIRD_PARTY_SG', // singular para contador
      THIRD_PARTY_PL: 'LAYOUT.THIRD_PARTY_PL', // plural para contador
    },
    THIRD_PARTY: {
      VINCULOS: {
        TITLE: 'LAYOUT.THIRD_PARTY.VINCULOS.TITLE',
        SUBTITLE: 'LAYOUT.THIRD_PARTY.VINCULOS.SUBTITLE',
        ACTIONS: {
          ADD: 'LAYOUT.THIRD_PARTY.VINCULOS.ACTIONS.ADD',
          SAVE: 'LAYOUT.THIRD_PARTY.VINCULOS.ACTIONS.SAVE',
          LINK_TYPE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.LINK_TYPE',
          CONTRALORIA_CODE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.CONTRALORIA_CODE',
          SUP_BANCARIA_CODE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.SUP_BANCARIA_CODE',
          SUP_BANCARIA_CODE_2: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.SUP_BANCARIA_CODE_2',
          SUB_BANCARIA_NAME_2: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.SUB_BANCARIA_NAME_2',
        },
      },
      CUENTAS_BANCO: {
        TITLE: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.TITLE',
        SUBTITLE: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.SUBTITLE',
        ACTIONS: {
          ADD: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.ACTIONS.ADD',
          CANCEL: 'ACTIONS.CANCEL',
          SAVE: 'ACTIONS.SAVE',
        },
      },
      TABLE: {
        BANK_ACCOUNTS: {
          BANK: 'LAYOUT.THIRD_PARTY.TABLE.BANK_ACCOUNTS.BANK',
          ACCOUNT_TYPE: 'LAYOUT.THIRD_PARTY.TABLE.BANK_ACCOUNTS.ACCOUNT_TYPE',
          ACCOUNT_NUMBER: 'LAYOUT.THIRD_PARTY.TABLE.BANK_ACCOUNTS.ACCOUNT_NUMBER',
        },
        VINCULOS: {
          TYPE: 'LAYOUT.THIRD_PARTY.TABLE.VINCULOS.TYPE',
          REGISTRATION_DATE: 'LAYOUT.THIRD_PARTY.TABLE.VINCULOS.REGISTRATION_DATE',
          CONTRALORIA_CODE: 'LAYOUT.THIRD_PARTY.TABLE.VINCULOS.CONTRALORIA_CODE',
          SUP_BANCARIA_CODE: 'LAYOUT.THIRD_PARTY.TABLE.VINCULOS.SUP_BANCARIA_CODE',
        },
      },
      FORM: {
        NAME_PLACEHOLDER: 'LAYOUT.PLAN_TYPE.FORM.NAME_PLACEHOLDER',
        BANK: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.BANK',
        ACCOUNT_TYPE: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.ACCOUNT_TYPE',
        ACCOUNT_NUMBER: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.ACCOUNT_NUMBER',
        BRE_B: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.BRE_B',
        STATUS: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.STATUS',
        TAX_DATA: 'LAYOUT.THIRD_PARTY.FORM.TAX_DATA',
        TAX_REGIME: 'LAYOUT.THIRD_PARTY.FORM.TAX_REGIME',
        ECONOMIC_ACTIVITY_CODE: 'LAYOUT.THIRD_PARTY.FORM.ECONOMIC_ACTIVITY_CODE',
        ECONOMIC_ACTIVITY_NAME: 'LAYOUT.THIRD_PARTY.FORM.ECONOMIC_ACTIVITY_NAME',
        AUTO_WITHHOLDING_INCOME: 'LAYOUT.THIRD_PARTY.FORM.AUTO_WITHHOLDING_INCOME',
        AUTO_WITHHOLDING_ICA: 'LAYOUT.THIRD_PARTY.FORM.AUTO_WITHHOLDING_ICA',
        MAJOR_CONTRIBUTOR: 'LAYOUT.THIRD_PARTY.FORM.MAJOR_CONTRIBUTOR',
        NOT_OBLIGED_TO_INVOICE: 'LAYOUT.THIRD_PARTY.FORM.NOT_OBLIGED_TO_INVOICE',
        GENERAL_DATA: 'LAYOUT.THIRD_PARTY.FORM.GENERAL_DATA',
        DOCUMENT_TYPE: 'LAYOUT.THIRD_PARTY.FORM.DOCUMENT_TYPE',
        DOCUMENT_NUMBER: 'LAYOUT.THIRD_PARTY.FORM.DOCUMENT_NUMBER',
        DV: 'LAYOUT.THIRD_PARTY.FORM.DV',
        PERSON_TYPE: 'LAYOUT.THIRD_PARTY.FORM.PERSON_TYPE',
        FIRST_NAME: 'LAYOUT.THIRD_PARTY.FORM.FIRST_NAME',
        SECOND_NAME: 'LAYOUT.THIRD_PARTY.FORM.SECOND_NAME',
        FIRST_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.FIRST_SURNAME',
        SECOND_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.SECOND_SURNAME',
        BUSINESS_NAME: 'LAYOUT.THIRD_PARTY.FORM.BUSINESS_NAME',
        ADDRESS: 'LAYOUT.THIRD_PARTY.FORM.ADDRESS',
        COUNTRY: 'LAYOUT.THIRD_PARTY.FORM.COUNTRY',
        CITY: 'LAYOUT.THIRD_PARTY.FORM.CITY',
        PHONE: 'LAYOUT.THIRD_PARTY.FORM.PHONE',
        MOBILE: 'LAYOUT.THIRD_PARTY.FORM.MOBILE',
        EMAIL: 'LAYOUT.THIRD_PARTY.FORM.EMAIL',
        VINCULOS: 'LAYOUT.THIRD_PARTY.FORM.VINCULOS',
        BANK_ACCOUNTS: 'LAYOUT.THIRD_PARTY.FORM.BANK_ACCOUNTS',
        OTHER_DATA: 'LAYOUT.THIRD_PARTY.FORM.OTHER_DATA',
        CEDULA_REPRESENTANTE: 'LAYOUT.THIRD_PARTY.FORM.CEDULA_REPRESENTANTE',
        NOMBRE_REPRESENTANTE: 'LAYOUT.THIRD_PARTY.FORM.NOMBRE_REPRESENTANTE',
        TARJETA_PROFESIONAL: 'LAYOUT.THIRD_PARTY.FORM.TARJETA_PROFESIONAL',
        OBSERVACIONES: 'LAYOUT.THIRD_PARTY.FORM.OBSERVACIONES',
        PLACEHOLDER: {
          LINK_TYPE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.LINK_TYPE',
          CONTRALORIA_CODE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.CONTRALORIA_CODE',
          SUP_BANCARIA_CODE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.SUP_BANCARIA_CODE',
          SUP_BANCARIA_CODE_2: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.SUP_BANCARIA_CODE_2',
          SUB_BANCARIA_NAME_2: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.PLACEHOLDER.SUB_BANCARIA_NAME_2',
          TAX_REGIME: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.TAX_REGIME',
          ECONOMIC_ACTIVITY_CODE: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.ECONOMIC_ACTIVITY_CODE',
          ECONOMIC_ACTIVITY_NAME: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.ECONOMIC_ACTIVITY_NAME',
          SELECT_OPTION: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.SELECT_OPTION',
          CEDULA_REPRESENTANTE: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.CEDULA_REPRESENTANTE',
          NOMBRE_REPRESENTANTE: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.NOMBRE_REPRESENTANTE',
          TARJETA_PROFESIONAL: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.TARJETA_PROFESIONAL',
          OBSERVACIONES: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.OBSERVACIONES',
          DOCUMENT_TYPE: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.DOCUMENT_TYPE',
          DOCUMENT_NUMBER: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.DOCUMENT_NUMBER',
          DV: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.DV',
          PERSON_TYPE: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.PERSON_TYPE',
          FIRST_NAME: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.FIRST_NAME',
          SECOND_NAME: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.SECOND_NAME',
          FIRST_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.FIRST_SURNAME',
          SECOND_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.SECOND_SURNAME',
          BUSINESS_NAME: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.BUSINESS_NAME',
          ADDRESS: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.ADDRESS',
          COUNTRY: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.COUNTRY',
          BANK: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.BANK',
          ACCOUNT_TYPE: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.ACCOUNT_TYPE',
          ACCOUNT_NUMBER: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.ACCOUNT_NUMBER',
          BRE_B: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.PLACEHOLDER.BRE_B',
          CITY: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.CITY',
          PHONE: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.PHONE',
          MOBILE: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.MOBILE',
          EMAIL: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.EMAIL',
          STATUS: 'LAYOUT.THIRD_PARTY.FORM.PLACEHOLDER.STATUS',
          SEARCH: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.PLACEHOLDER.SEARCH',
          SEARCH_VINCULOS: 'LAYOUT.THIRD_PARTY.VINCULOS.PLACEHOLDER.SEARCH',
        },
        TOOLTIP: {
          LINK_TYPE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.LINK_TYPE',
          CONTRALORIA_CODE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.CONTRALORIA_CODE',
          SUP_BANCARIA_CODE: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.SUP_BANCARIA_CODE',
          SUP_BANCARIA_CODE_2: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.SUP_BANCARIA_CODE_2',
          SUB_BANCARIA_NAME_2: 'LAYOUT.THIRD_PARTY.VINCULOS.FORM.TOOLTIP.SUB_BANCARIA_NAME_2',
          CEDULA_REPRESENTANTE: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.CEDULA_REPRESENTANTE',
          NOMBRE_REPRESENTANTE: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.NOMBRE_REPRESENTANTE',
          TARJETA_PROFESIONAL: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.TARJETA_PROFESIONAL',
          OBSERVACIONES: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.OBSERVACIONES',
          DOCUMENT_TYPE: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.DOCUMENT_TYPE',
          DOCUMENT_NUMBER: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.DOCUMENT_NUMBER',
          DV: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.DV',
          PERSON_TYPE: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.PERSON_TYPE',
          FIRST_NAME: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.FIRST_NAME',
          SECOND_NAME: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.SECOND_NAME',
          FIRST_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.FIRST_SURNAME',
          SECOND_SURNAME: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.SECOND_SURNAME',
          BUSINESS_NAME: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.BUSINESS_NAME',
          ADDRESS: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.ADDRESS',
          COUNTRY: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.COUNTRY',
          CITY: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.CITY',
          PHONE: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.PHONE',
          MOBILE: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.MOBILE',
          EMAIL: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.EMAIL',
          STATUS: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.STATUS',
          TAX_REGIME: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.TAX_REGIME',
          ECONOMIC_ACTIVITY_CODE: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.ECONOMIC_ACTIVITY_CODE',
          ECONOMIC_ACTIVITY_NAME: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.ECONOMIC_ACTIVITY_NAME',
          AUTO_WITHHOLDING_INCOME: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.AUTO_WITHHOLDING_INCOME',
          AUTO_WITHHOLDING_ICA: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.AUTO_WITHHOLDING_ICA',
          MAJOR_CONTRIBUTOR: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.MAJOR_CONTRIBUTOR',
          NOT_OBLIGED_TO_INVOICE: 'LAYOUT.THIRD_PARTY.FORM.TOOLTIP.NOT_OBLIGED_TO_INVOICE',
          BANK: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.BANK',
          ACCOUNT_TYPE: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.ACCOUNT_TYPE',
          ACCOUNT_NUMBER: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.ACCOUNT_NUMBER',
          BRE_B: 'LAYOUT.THIRD_PARTY.CUENTAS_BANCO.FORM.TOOLTIP.BRE_B',
        },
      },
    },
    //TIPOS DE PLAN
    PLAN_TYPE: {
      LIST: 'LAYOUT.PLAN_TYPE.TITLE.LIST',
      CREATE: 'LAYOUT.PLAN_TYPE.TITLE.CREATE',
      EDIT: 'LAYOUT.PLAN_TYPE.TITLE.EDIT',
      VIEW: 'LAYOUT.PLAN_TYPE.TITLE.VIEW',
      SINGULAR: 'LAYOUT.PLAN_TYPE.SINGULAR',
      PLURAL: 'LAYOUT.PLAN_TYPE.PLURAL',
      SEARCH_PLACEHOLDER: 'LAYOUT.PLAN_TYPE.SEARCH_PLACEHOLDER',
      LIST_SUBTITLE: 'LAYOUT.PLAN_TYPE.SUBTITLE.LIST',
      CREATE_SUBTITLE: 'LAYOUT.PLAN_TYPE.SUBTITLE.CREATE',
      EDIT_SUBTITLE: 'LAYOUT.PLAN_TYPE.SUBTITLE.EDIT',
      VIEW_SUBTITLE: 'LAYOUT.PLAN_TYPE.SUBTITLE.VIEW',
      CODE_LABEL: 'LAYOUT.PLAN_TYPE.FORM.CODE_LABEL',
      CODE_PLACEHOLDER: 'LAYOUT.PLAN_TYPE.FORM.CODE_PLACEHOLDER',
      CODE_TOOLTIP: 'LAYOUT.PLAN_TYPE.FORM.CODE_TOOLTIP',
      CODE: 'LAYOUT.PLAN_TYPE.FORM.CODE',
      NAME: 'LAYOUT.PLAN_TYPE.FORM.NAME',
      NAME_PLACEHOLDER: 'LAYOUT.PLAN_TYPE.FORM.NAME_PLACEHOLDER',
      NAME_TOOLTIP: 'LAYOUT.PLAN_TYPE.FORM.NAME_TOOLTIP',
      MESSAGE: 'LAYOUT.PLAN_TYPE.EMPTY.MESSAGE',
      DESCRIPTION: 'LAYOUT.PLAN_TYPE.EMPTY.DESCRIPTION',
    },
    //Tipos de centro de costos
    COST_CENTER_TYPE: {
      SINGULAR: 'LAYOUT.COST_CENTER_TYPE.SINGULAR',
      PLURAL: 'LAYOUT.COST_CENTER_TYPE.PLURAL',
      LIST: 'LAYOUT.COST_CENTER_TYPE.TITLE.LIST',
      CREATE: 'LAYOUT.COST_CENTER_TYPE.TITLE.CREATE',
      EDIT: 'LAYOUT.COST_CENTER_TYPE.TITLE.EDIT',
      VIEW: 'LAYOUT.COST_CENTER_TYPE.TITLE.VIEW',
      SUBTITLE: {
        LIST: 'LAYOUT.COST_CENTER_TYPE.SUBTITLE.LIST',
        CREATE: 'LAYOUT.COST_CENTER_TYPE.SUBTITLE.CREATE',
        EDIT: 'LAYOUT.COST_CENTER_TYPE.SUBTITLE.EDIT',
        VIEW: 'LAYOUT.COST_CENTER_TYPE.SUBTITLE.VIEW',
        CODE: 'LAYOUT.COST_CENTER_TYPE.FORM.CODE',
        NAME: 'LAYOUT.COST_CENTER_TYPE.FORM.NAME',
        STATUS: 'LAYOUT.COST_CENTER_TYPE.FORM.STATUS',
      },
      VALIDATION: {
        REQUIRED: 'LAYOUT.VALIDATION.REQUIRED',
      },
      EMPTY: {
        MESSAGE: 'LAYOUT.COST_CENTER_TYPE.EMPTY.MESSAGE',
        DESCRIPTION: 'LAYOUT.COST_CENTER_TYPE.EMPTY.DESCRIPTION',
      },
      CODE: 'LAYOUT.COST_CENTER_TYPE.FORM.CODE',
      PLACEHOLDER: {
        CODE: 'LAYOUT.COST_CENTER_TYPE.FORM.PLACEHOLDER.CODE',
        NAME: 'LAYOUT.COST_CENTER_TYPE.FORM.PLACEHOLDER.NAME',
        STATUS: 'LAYOUT.COST_CENTER_TYPE.FORM.PLACEHOLDER.STATUS',
        SEARCH_PLACEHOLDER: 'LAYOUT.COST_CENTER_TYPE.SEARCH_PLACEHOLDER',
      },
      TOOLTIP: {
        CODE: 'LAYOUT.COST_CENTER_TYPE.FORM.TOOLTIP.CODE',
        NAME: 'LAYOUT.COST_CENTER_TYPE.FORM.TOOLTIP.NAME',
        STATUS: 'LAYOUT.COST_CENTER_TYPE.FORM.TOOLTIP.STATUS',
        MESSAGES: {
          ACTIVE_RECORD: 'LAYOUT.COST_CENTER_TYPE.MESSAGES.ACTIVE_RECORD',
          CANNOT_DELETE: 'LAYOUT.COST_CENTER_TYPE.MESSAGES.CANNOT_DELETE',
          ASSOCIATED_TO_COST_CENTER: 'LAYOUT.COST_CENTER_TYPE.MESSAGES.ASSOCIATED_TO_COST_CENTER',
          CANNOT_EDIT: 'LAYOUT.COST_CENTER_TYPE.MESSAGES.CANNOT_EDIT',
          VIEW_LOAD_ERROR: 'LAYOUT.COST_CENTER_TYPE.MESSAGES.VIEW_LOAD_ERROR',
          EDIT_LOAD_ERROR: 'LAYOUT.COST_CENTER_TYPE.MESSAGES.EDIT_LOAD_ERROR',
        },
      },
    },
    //Conceptos DIAN
    CONCEPT_DIAN: {
      MESSAGES: {
        CONFIRM_DELETE: {
          TITLE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.CONFIRM_DELETE.TITLE',
          MESSAGE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.CONFIRM_DELETE.MESSAGE',
          CONFIRM: 'LAYOUT.DIAN_CONCEPT.MESSAGES.CONFIRM_DELETE.CONFIRM',
          CANCEL: 'LAYOUT.DIAN_CONCEPT.MESSAGES.CONFIRM_DELETE.CANCEL',
        },
        SUCCESS: {
          CREATE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.SUCCESS.CREATE',
          UPDATE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.SUCCESS.UPDATE',
          DELETE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.SUCCESS.DELETE',
          CANNOT_DELETE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.CANNOT_DELETE',
          ERROR: {
            CREATE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.ERROR.CREATE',
            UPDATE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.ERROR.UPDATE',
            DELETE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.ERROR.DELETE',
            LOAD: 'LAYOUT.DIAN_CONCEPT.MESSAGES.ERROR.LOAD',
            LOAD_DETAIL: 'LAYOUT.DIAN_CONCEPT.MESSAGES.ERROR.LOAD_DETAIL',
            LOAD_DETAIL_WITH_NAME: 'LAYOUT.DIAN_CONCEPT.MESSAGES.ERROR.LOAD_DETAIL_WITH_NAME',
            ERROR_DUPLICATE_TITLE: 'LAYOUT.COMMON.ERROR_DUPLICATE_TITLE',
            CANNOT_EDIT: 'LAYOUT.DIAN_CONCEPT.MESSAGES.CANNOT_EDIT',
            CANNOT_EDIT_INACTIVE: 'LAYOUT.DIAN_CONCEPT.MESSAGES.ERROR.CANNOT_EDIT_INACTIVE',
            CANNOT_DELETE_ASSOCIATED: 'LAYOUT.DIAN_CONCEPT.MESSAGES.ERROR.CANNOT_DELETE_ASSOCIATED',
          },
        },
      },

      VALIDATION: {
        DIAN_CODE_REQUIRED: 'LAYOUT.DIAN_CONCEPT.VALIDATION.DIAN_CODE_REQUIRED',
        NAME_REQUIRED: 'LAYOUT.DIAN_CONCEPT.VALIDATION.NAME_REQUIRED',
        TYPE_REQUIRED: 'LAYOUT.DIAN_CONCEPT.VALIDATION.TYPE_REQUIRED',
        REQUIRED: 'LAYOUT.DIAN_CONCEPT.VALIDATION.REQUIRED',
        MAX_LENGTH: 'LAYOUT.DIAN_CONCEPT.VALIDATION.MAX_LENGTH',
        REQUIRED_FIELDS: 'LAYOUT.DIAN_CONCEPT.VALIDATION.REQUIRED_FIELDS',
      },

      TITLE: {
        LIST: 'LAYOUT.CONCEPT_DIAN.TITLE.LIST',
        CREATE: 'LAYOUT.CONCEPT_DIAN.TITLE.CREATE',
        EDIT: 'LAYOUT.CONCEPT_DIAN.TITLE.EDIT',
        VIEW: 'LAYOUT.CONCEPT_DIAN.TITLE.VIEW',
        CODE: 'LAYOUT.DIAN_CONCEPT.FORM.CODE',
        NAME: 'LAYOUT.DIAN_CONCEPT.FORM.NAME',
        TYPE: 'LAYOUT.DIAN_CONCEPT.FORM.TYPE',
        TOTALIZES: 'LAYOUT.DIAN_CONCEPT.FORM.TOTALIZES',
        DIAN_CODE: 'LAYOUT.DIAN_CONCEPT.FORM.DIAN_CODE',
        TAX_YEAR: 'LAYOUT.DIAN_CONCEPT.FORM.TAX_YEAR',
        STATUS: 'LAYOUT.DIAN_CONCEPT.FORM.STATUS',
        SINGULAR: 'LAYOUT.DIAN_CONCEPT.SINGULAR',
        PLURAL: 'LAYOUT.DIAN_CONCEPT.PLURAL',
        DATO_TRABAJADOR: 'LAYOUT.DIAN_CONCEPT.OPTIONS.TYPE.DATO_TRABAJADOR',
      },
      SUBTITLE: {
        LIST: 'LAYOUT.CONCEPT_DIAN.SUBTITLE.LIST',
        CREATE: 'LAYOUT.CONCEPT_DIAN.SUBTITLE.CREATE',
        EDIT: 'LAYOUT.CONCEPT_DIAN.SUBTITLE.EDIT',
        VIEW: 'LAYOUT.CONCEPT_DIAN.SUBTITLE.VIEW',
      },
      PLACEHOLDER: {
        CODE: 'LAYOUT.DIAN_CONCEPT.FORM.PLACEHOLDER.CODE',
        NAME: 'LAYOUT.DIAN_CONCEPT.FORM.PLACEHOLDER.NAME',
        TYPE: 'LAYOUT.DIAN_CONCEPT.FORM.PLACEHOLDER.TYPE',
        TOTALIZES: 'LAYOUT.DIAN_CONCEPT.FORM.PLACEHOLDER.TOTALIZES',
        DIAN_CODE: 'LAYOUT.DIAN_CONCEPT.FORM.PLACEHOLDER.DIAN_CODE',
        TAX_YEAR: 'LAYOUT.DIAN_CONCEPT.FORM.PLACEHOLDER.TAX_YEAR',
        STATUS: 'LAYOUT.DIAN_CONCEPT.FORM.PLACEHOLDER.STATUS',
      },
      TOOLTIP: {
        CODE: 'LAYOUT.DIAN_CONCEPT.FORM.TOOLTIP.CODE',
        NAME: 'LAYOUT.DIAN_CONCEPT.FORM.TOOLTIP.NAME',
        TYPE: 'LAYOUT.DIAN_CONCEPT.FORM.TOOLTIP.TYPE',
        TOTALIZES: 'LAYOUT.DIAN_CONCEPT.FORM.TOOLTIP.TOTALIZES',
        DIAN_CODE: 'LAYOUT.DIAN_CONCEPT.FORM.TOOLTIP.DIAN_CODE',
        TAX_YEAR: 'LAYOUT.DIAN_CONCEPT.FORM.TOOLTIP.TAX_YEAR',
        STATUS: 'LAYOUT.DIAN_CONCEPT.FORM.TOOLTIP.STATUS',
      },
      TABLE: {
        CODE: 'LAYOUT.CONCEPT_DIAN.TABLE.CODE',
        NAME: 'LAYOUT.CONCEPT_DIAN.TABLE.NAME',
        TYPE: 'LAYOUT.CONCEPT_DIAN.TABLE.TYPE',
        TOTALIZES: 'LAYOUT.CONCEPT_DIAN.TABLE.TOTALIZES',
      },
      OPTIONS: {
        TYPE: {
          INGRESO: 'LAYOUT.CONCEPT_DIAN.OPTIONS.TYPE.INGRESO',
          APORTE: 'LAYOUT.CONCEPT_DIAN.OPTIONS.TYPE.APORTE',
          RETENCION: 'LAYOUT.CONCEPT_DIAN.OPTIONS.TYPE.RETENCION',
          DATO_TRABAJADOR: 'LAYOUT.CONCEPT_DIAN.OPTIONS.TYPE.DATO_TRABAJADOR',
        },
        EMPTY: {
          MESSAGE: 'LAYOUT.CONCEPT_DIAN.EMPTY.MESSAGE',
          DESCRIPTION: 'LAYOUT.CONCEPT_DIAN.EMPTY.DESCRIPTION',
        },
      },
    },
    // Breadcrumbs (migajas de pan)
    BREADCRUMB: {
      ACCOUNTING: 'BC.accounting',
      ACCOUNTING_FORMAT: 'BC.accounting-format',
      ACCOUNTING_PARAMETERS: 'BC.accounting-parameters',
      ACCOUNT_PLAN: 'BC.account-plan',
      ACCOUNT_STRUCTURE: 'BC.account-structure',
      ACCRUAL: 'BC.accrual',
      ADMIN: 'BC.admin',
      AUDIT: 'BC.audit',
      BUDGET: 'BC.budget',
      CITY: 'BC.ciudades',
      CLOUD: 'BC.cloud',
      COST_CENTER: 'BC.cost-center',
      COST_CENTER_TYPE: 'BC.cost-center-type',
      CREATE: 'BC.create',
      DASHBOARD: 'BC.dashboard',
      DEFERRED_PROCESS: 'BC.deferred-process',
      DEPARTMENTS: 'BC.departamentos',
      DEPENDENCY: 'BC.dependency',
      DETAIL: 'BC.detail',
      DIAN_CONCEPT: 'BC.dian-concept',
      EDIT: 'BC.edit',
      INGEST: 'BC.ingest',
      JOURNAL_ENTRY: 'BC.journal-entry',
      LEGAL_HOLD: 'BC.legal-hold',
      LIST: 'BC.list',
      MASTERS: 'BC.masters',
      NOTIFICATIONS: 'BC.notifications',
      PAISES: 'BC.paises',
      PERMISSIONS: 'BC.permissions',
      PRESERVATION: 'BC.preservation',
      PRESERVATION_MESSAGES: 'BC.preservation-messages',
      REPORTS: 'BC.reports',
      REPOSITORY_ADMIN: 'BC.repository-admin',
      RETENTION: 'BC.retention',
      SERVERS: 'BC.servers',
      SETTINGS: 'BC.settings',
      TENANTS: 'BC.tenants',
      TERCEROS: 'BC.third-party',
      TIPO_PLAN: 'BC.tipo-plan',
      TIPO_PLAN_HISTORICO: 'BC.tipo-plan-historico',
      TREASURY: 'BC.tesorería',
      VAULT: 'BC.vault',
      VIEW: 'BC.view',
    },
  } as const,
};
